export class PaymentPricing {
  fixedPrice: number;
  variablePrice: number;
  totalPrice: number;
}
